import { render } from "./IconPlusCross.vue?vue&type=template&id=b075fcb2"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconPlusCross.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b075fcb2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b075fcb2', __exports__)) {
    api.reload('b075fcb2', __exports__)
  }
  
  module.hot.accept("./IconPlusCross.vue?vue&type=template&id=b075fcb2", () => {
    api.rerender('b075fcb2', render)
  })

}


export default __exports__